import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const StatusBulkUpdateContext = createContext(null);

type Props = {
  children: ReactElement;
};

const StatusBulkUpdateProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put(
        `backoffice/onboarding/risk-profiles/status-update`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      isPending,
      error,
    }),
    [mutateAsync, data, isPending, error],
  );
  return (
    <StatusBulkUpdateContext.Provider value={contextValue}>
      {children}
    </StatusBulkUpdateContext.Provider>
  );
};

export default StatusBulkUpdateProvider;
